module.exports = __webpack_public_path__ + "static/media/Goals.b3ff1afd.png";